import { app } from "./app";
import { getStorage } from "firebase/storage";
import type { FirebaseStorage } from "firebase/storage";

export const storage: FirebaseStorage = getStorage(app);
